import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { PasswordInput } from './PasswordInput';
import { APP_TITLE } from './LoginPage';
import './auth.css';

export function ChangePasswordPage({ onDone }: { onDone?: () => void }) {
  const { session, changePassword, logout } = useAuth();
  const forced = session?.mustChangePassword ?? false;
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await changePassword(forced ? null : oldPassword, newPassword);
      onDone?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-subtitle">{APP_TITLE}</h2>
        <p className="auth-card-heading">{forced ? 'Set new password' : 'Change password'}</p>
        <form onSubmit={handleSubmit} autoComplete="off" data-form-type="other">
          {error && <div className="auth-error">{error}</div>}
          {!forced && (
            <div className="auth-field">
              <label htmlFor="oldPassword">Current password</label>
              <PasswordInput
                id="oldPassword"
                name="current-password"
                value={oldPassword}
                onChange={setOldPassword}
                autoComplete="current-password"
                ignorePasswordManager
                required
              />
            </div>
          )}
          <div className="auth-field">
            <label htmlFor="newPassword">New password</label>
            <PasswordInput
              id="newPassword"
              name="new-password"
              value={newPassword}
              onChange={setNewPassword}
              autoComplete="new-password"
              ignorePasswordManager
              required
              minLength={6}
            />
          </div>
          <div className="auth-field">
            <label htmlFor="confirm">Confirm new password</label>
            <PasswordInput
              id="confirm"
              name="confirm-new-password"
              value={confirm}
              onChange={setConfirm}
              autoComplete="new-password"
              ignorePasswordManager
              required
              minLength={6}
            />
          </div>
          <button type="submit" className="button primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Saving…' : 'Save password'}
          </button>
          {!forced && (
            <button
              type="button"
              className="auth-link-btn"
              style={{ marginTop: 12, display: 'block', width: '100%', textAlign: 'center' }}
              onClick={onDone}
            >
              Cancel
            </button>
          )}
          {forced && (
            <button
              type="button"
              className="auth-link-btn"
              style={{ marginTop: 12, display: 'block', width: '100%', textAlign: 'center' }}
              onClick={logout}
            >
              Logout
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
